import React from 'react';

interface CheckboxFieldProps {
  name: string;
  id: string;
  label?: React.ReactNode;
  disabled?: boolean;
  value: boolean;
  onChange: (value?: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckboxField: React.FC<CheckboxFieldProps> = ({ name, disabled, id, value, label, ...restProps }) => (
  <label className="checkbox">
    <input {...restProps} id={id} name={name} value={id} type="checkbox" disabled={disabled} checked={Boolean(value)} />
    <i />
    {label ? <span>{label}</span> : null}
  </label>
);

export default CheckboxField;
